import React from "react";

const WizardDraftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M12.3567 9.92614C12.4677 9.64484 12.8655 9.64484 12.9765 9.92614L13.3678 10.9177C13.4016 11.0035 13.4695 11.0713 13.5553 11.1052L14.5468 11.4965C14.8282 11.6074 14.8282 12.0059 14.5468 12.1169L13.5553 12.5075C13.4694 12.5414 13.4016 12.6098 13.3678 12.6957L12.9765 13.6872C12.8654 13.9682 12.4678 13.9682 12.3567 13.6872L11.9654 12.6957C11.9316 12.6098 11.8637 12.5414 11.7779 12.5075L10.7864 12.1169C10.505 12.0059 10.505 11.6074 10.7864 11.4965L11.7779 11.1052L10.3144 11.6826L10.4303 11.6358L11.7786 11.1045C11.8639 11.0705 11.9317 11.0032 11.9654 10.9177L12.3567 9.92614Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.17896 2.17614C7.70088 1.94129 8.29896 1.94129 8.82088 2.17614L13.4875 4.27575C14.2051 4.59872 14.6665 5.31303 14.6666 6.09997V10.3962L14.2428 10.2295L13.7831 9.06286L13.7428 8.97106C13.3096 8.08059 12.0236 8.08059 11.5904 8.97106L11.55 9.06286L11.0898 10.2295L9.9231 10.6898C8.91014 11.0893 8.9102 12.5233 9.9231 12.9229L11.0898 13.3825L11.2571 13.8063H3.33325C2.22868 13.8063 1.33325 12.9109 1.33325 11.8063V6.09997C1.3333 5.31303 1.79469 4.59872 2.51229 4.27575L7.17896 2.17614ZM12.5546 6.10322C12.3631 5.81628 11.9873 5.7253 11.6887 5.88317L11.6301 5.91833L8.36971 8.09215C8.17372 8.22275 7.92564 8.23904 7.71672 8.14098L7.63013 8.09215L4.36971 5.91833L4.31112 5.88317C4.01259 5.7253 3.63671 5.81628 3.44523 6.10322C3.25375 6.39044 3.31463 6.77246 3.57544 6.98734L3.63013 7.0277L6.89054 9.20153L7.0188 9.28031C7.67089 9.64759 8.47954 9.6213 9.10929 9.20153L12.3697 7.0277L12.4244 6.98734C12.6852 6.77246 12.7461 6.39044 12.5546 6.10322Z"
        fill="white"
      />
      <path
        d="M12.5644 9.41768L12.5422 9.45413C12.5478 9.44009 12.555 9.42755 12.5637 9.41702L12.5937 9.39098C12.5828 9.39801 12.573 9.40715 12.5644 9.41768Z"
        fill="white"
      />
      <path
        d="M12.7695 9.41702L12.7909 9.45413C12.7854 9.44015 12.7774 9.42818 12.7688 9.41768L12.7395 9.39098C12.7504 9.39798 12.7608 9.40654 12.7695 9.41702Z"
        fill="white"
      />
    </svg>
  );
};

export default WizardDraftIcon;
